<div class="me-dashboard--col bg">
    <h2 class="color-primary">Made to help you quickly</h2>
    <p class="">Understanding mental health problems is not always easy. Klenico
        helps you to recognize and understand possible symptoms and get the right help.</p>
    <button class="btn btn--primary w-100" (click)="goToSR()">Start Mental Health Check</button>
</div>